//dependencies
import React from "react";

import PageTitle from "../../components/PageTitle";
//components
import Spacer from "../../components/Spacer";

// css
import css from "./BasePageTemplate.module.scss";

type BasePageTemplateProps = {
	children: React.ReactNode;
	title?: string;
	backgroundColor?: "light" | "grey";
};

const BasePageTemplate = ({ children, title, backgroundColor = "light" }: BasePageTemplateProps) => {
	return (
		<div className={`${css.pageContainer}`}>
			{title ? <PageTitle title={title} /> : null}
			<div className={`${css.background} ${css[backgroundColor]}`} />
			<div className={`${css.pageContents}`}>
				{children}
				<Spacer height={9} />
			</div>
		</div>
	);
};

export default BasePageTemplate;
